import React, { useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { AnnotationProvider, AnnotationToggle, useAnno } from "./Annotate";
import { MONO, SANS } from "./brand";

const TABS = [
  { to: "/axos", label: "Landing page" },
  { to: "/axos/quiz", label: "Quiz" },
  { to: "/axos/advertorial", label: "Advertorial" },
  { to: "/axos/listicle", label: "Listicle" },
  { to: "/axos/emails", label: "Emails" },
];

export default function AxosShell({ pins, kicker, children }) {
  return (
    <AnnotationProvider pins={pins}>
      <ShellFrame kicker={kicker}>{children}</ShellFrame>
    </AnnotationProvider>
  );
}

function ShellFrame({ kicker, children }) {
  const anno = useAnno();
  const { pathname } = useLocation();
  const [intro, setIntro] = useState(true);
  const [sp] = useSearchParams();

  /* embedded inside the machine page: the page only, no harness */
  if (sp.get("embed") === "1") {
    return (
      <div style={{ fontFamily: SANS }} data-testid="axos-embed">
        {children}
      </div>
    );
  }
  return (
    <div style={{ fontFamily: SANS }}>
        {/* operator bar. not part of the Axos page, it is the harness around it */}
        <div
          className="fixed left-0 right-0 top-0 z-[90] flex flex-wrap items-center gap-x-4 gap-y-2 border-b px-4 py-2.5 sm:px-6"
          style={{ background: "rgba(8,9,11,0.92)", borderColor: "#1E2530", backdropFilter: "blur(14px)" }}
        >
          <Link
            to="/"
            data-testid="axos-back"
            className="text-[10px] uppercase tracking-[0.16em]"
            style={{ fontFamily: MONO, color: "#5FE3A1" }}
          >
            ← The machine
          </Link>
          <span className="hidden h-4 w-px sm:block" style={{ background: "#242C38" }} />
          <div className="flex flex-wrap items-center gap-1">
            {TABS.map((t) => {
              const live = pathname === t.to;
              return (
                <Link
                  key={t.to}
                  to={t.to}
                  data-testid={`axos-tab-${t.to.split("/").pop()}`}
                  className="rounded-full px-3 py-1 text-[11.5px] transition-colors"
                  style={{
                    color: live ? "#0B0D11" : "#9AA6B6",
                    background: live ? "#E7ECF3" : "transparent",
                    border: `1px solid ${live ? "#E7ECF3" : "#242C38"}`,
                  }}
                >
                  {t.label}
                </Link>
              );
            })}
          </div>
          <div className="ml-auto flex items-center gap-3">
            <span className="hidden text-[10px] uppercase tracking-[0.14em] sm:inline" style={{ fontFamily: MONO, color: "#5F6B7A" }}>
              {kicker}
            </span>
            <AnnotationToggle />
          </div>
        </div>

        <div className={anno.on ? "anno-open" : ""} style={{ paddingTop: 58, transition: "padding-right 220ms ease" }}>
          {intro && (
            <div
              className="flex flex-wrap items-start gap-x-6 gap-y-2 border-b px-5 py-3.5 sm:px-8"
              style={{ background: "#0B0D11", borderColor: "#1E2530" }}
              data-testid="axos-intro-band"
            >
              <span className="text-[10px] uppercase tracking-[0.16em]" style={{ fontFamily: MONO, color: "#5FE3A1", paddingTop: 2 }}>
                Real brand
              </span>
              <p className="min-w-[260px] flex-1 text-[12.5px] leading-relaxed" style={{ color: "#9AA6B6" }}>
                This is Axos, ibdassist.com, a store this system runs end to end. The page below is their real layout,
                rebuilt here so you can walk it. Turn on the split test layer to see every piece we tested, what won,
                what died and what shipped. Your account gets the same treatment.
              </p>
              <button
                type="button"
                data-testid="axos-intro-dismiss"
                onClick={() => setIntro(false)}
                className="rounded px-2.5 py-1 text-[10.5px]"
                style={{ color: "#7E8B9E", border: "1px solid #242C38" }}
              >
                Got it
              </button>
            </div>
          )}
          {children}
        </div>
    </div>
  );
}
